import { useCallback, useMemo } from "react";
import api from "../../services/api";

const useTicketNotes = () => {

    const saveNote = useCallback(async (data) => {
        const { data: responseData } = await api.request({
            url: '/ticket-notes',
            method: 'POST',
            data
        });
        return responseData;
    }, []);

    const deleteNote = useCallback(async (id) => {
        const { data } = await api.request({
            url: `/ticket-notes/${id}`,
            method: 'DELETE'
        });
        return data;
    }, []);

    const listNotes = useCallback(async (params) => {
        if (!params) return;
        const { data } = await api.request({
            url: '/ticket-notes/list',
            method: 'GET',
            params
        });
        return data;
    }, []);

    return useMemo(() => ({
        saveNote,
        deleteNote,
        listNotes
    }), [saveNote, deleteNote, listNotes]);
};

export default useTicketNotes;
